"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypography = void 0;
var createTypography_1 = __importDefault(require("@material-ui/core/styles/createTypography"));
exports.createTypography = function (props, palette, breakpoints) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26;
    return createTypography_1.default(palette, {
        h1: {
            fontFamily: "Gilroy",
            fontWeight: 600,
            fontSize: 72,
            lineHeight: "87px",
            color: "#1B1C1F",
        },
        h2: {
            fontFamily: "Gilroy",
            fontWeight: 600,
            fontSize: 56,
            lineHeight: "72px",
            color: "#1B1C1F",
        },
        h3: {
            fontFamily: "Gilroy",
            fontWeight: 600,
            fontSize: 48,
            lineHeight: "72px",
            color: "#1B1C1F",
        },
        h4: {
            fontFamily: "Gilroy",
            fontWeight: 600,
            fontSize: 36,
            lineHeight: "48px",
            color: "#1B1C1F",
        },
        h5: {
            fontFamily: "Gilroy",
            fontWeight: 500,
            fontSize: 24,
            lineHeight: "32px",
            color: "#1B1C1F",
        },
        h6: {
            fontFamily: "Gilroy",
            fontWeight: 500,
            fontSize: 20,
            lineHeight: "72px",
            color: "#1B1C1F",
        },
        body1: {
            fontFamily: "Gilroy",
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "32px",
            color: "#8D9299",
        },
        body2: {
            fontFamily: "Gilroy",
            fontWeight: 300,
            fontSize: 12,
            color: "#8D9299",
        },
        subtitle1: {
            fontFamily: "Gilroy",
            fontWeight: 400,
            fontSize: 16,
            color: "#8D9299",
        },
        subtitle2: {
            fontFamily: "Gilroy",
            fontWeight: 400,
            fontSize: 12,
            color: "#8D9299",
        },
        button: {
            fontFamily: "Gilroy",
            fontWeight: 600,
            textTransform: "none",
            fontSize: 16,
            color: undefined,
            lineHeight: 1.25,
        },
        display1SemiBold: (_a = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 72,
                lineHeight: "84px",
                letterSpacing: "-0.04em",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _a[breakpoints.down("md")] = {
                fontSize: 56,
                lineHeight: "68px",
            },
            _a),
        display1Bold: (_b = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 72,
                lineHeight: "84px",
                letterSpacing: "-0.04em",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _b[breakpoints.down("md")] = {
                fontSize: 56,
                lineHeight: "68px",
            },
            _b),
        display1ExtraBold: (_c = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 72,
                lineHeight: "84px",
                fontWeight: 100,
                letterSpacing: "-0.04em",
                color: palette.neutral["900"]
            },
            _c[breakpoints.down("md")] = {
                fontSize: 56,
                lineHeight: "68px",
            },
            _c),
        display2SemiBold: (_d = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 100,
                letterSpacing: "-0.04em",
                color: palette.neutral["900"]
            },
            _d[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _d),
        display2Bold: (_e = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 100,
                letterSpacing: "-0.04em",
                color: palette.neutral["900"]
            },
            _e[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _e),
        display2ExtraBold: (_f = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 100,
                letterSpacing: "-0.04em",
                color: palette.neutral["900"]
            },
            _f[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _f),
        h1SemiBold: (_g = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 48,
                fontWeight: 100,
                lineHeight: "60px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _g[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _g),
        h1Bold: (_h = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 48,
                fontWeight: 100,
                lineHeight: "60px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _h[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _h),
        h1ExtraBold: (_j = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 48,
                fontWeight: 100,
                lineHeight: "60px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _j[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _j),
        h2SemiBold: (_k = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 40,
                fontWeight: 100,
                lineHeight: "52px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _k[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _k),
        h2Bold: (_l = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 40,
                fontWeight: 100,
                lineHeight: "52px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _l[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _l),
        h2ExtraBold: (_m = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 40,
                fontWeight: 100,
                lineHeight: "52px",
                letterSpacing: "-0.02em",
                color: palette.neutral["900"]
            },
            _m[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _m),
        h3SemiBold: (_o = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _o[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _o),
        h3Bold: (_p = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _p[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _p),
        h3ExtraBold: (_q = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _q[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _q),
        h4SemiBold: (_r = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _r[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _r),
        h4Bold: (_s = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _s[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _s),
        h4ExtraBold: (_t = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _t[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _t),
        h5SemiBold: (_u = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _u[breakpoints.down("md")] = {
                fontSize: 16,
                lineHeight: "24px",
            },
            _u),
        h5Bold: (_v = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _v[breakpoints.down("md")] = {
                fontSize: 16,
                lineHeight: "24px",
            },
            _v),
        h5ExtraBold: (_w = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _w[breakpoints.down("md")] = {
                fontSize: 16,
                lineHeight: "24px",
            },
            _w),
        h6SemiBold: (_x = {
                fontFamily: "Gilroy-SemiBold-v2",
                fontSize: 16,
                lineHeight: "24px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _x[breakpoints.down("md")] = {
                fontSize: 14,
                lineHeight: "20px",
            },
            _x),
        h6Bold: (_y = {
                fontFamily: "Gilroy-Bold-v2",
                fontSize: 16,
                lineHeight: "24px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _y[breakpoints.down("md")] = {
                fontSize: 14,
                lineHeight: "20px",
            },
            _y),
        h6ExtraBold: (_z = {
                fontFamily: "Gilroy-ExtraBold-v2",
                fontSize: 16,
                lineHeight: "24px",
                fontWeight: 100,
                color: palette.neutral["900"]
            },
            _z[breakpoints.down("md")] = {
                fontSize: 14,
                lineHeight: "20px",
            },
            _z),
        body1Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        body1SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        body2Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 14,
            lineHeight: "20px",
            color: palette.neutral["900"],
        },
        body2SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 14,
            lineHeight: "20px",
            color: palette.neutral["900"],
        },
        body3Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 12,
            lineHeight: "16px",
            color: palette.neutral["900"],
        },
        body3SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 12,
            lineHeight: "16px",
            color: palette.neutral["900"],
        },
        overlineSmall: {
            fontFamily: "Gilroy-Medium-v2",
            textTransform: "capitalize",
            fontSize: 12,
            lineHeight: "16px",
            color: palette.neutral["900"],
        },
        overlineMedium: {
            fontFamily: "Gilroy-Medium-v2",
            textTransform: "capitalize",
            fontSize: 14,
            lineHeight: "20px",
            color: palette.neutral["900"],
        },
        overlineLarge: {
            fontFamily: "Gilroy-Medium-v2",
            textTransform: "capitalize",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        subtitle1Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 24,
            lineHeight: "32px",
            color: palette.neutral["900"],
        },
        subtitle1SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 24,
            lineHeight: "32px",
            color: palette.neutral["900"],
        },
        subtitle1MediumItalic: {
            fontFamily: "Gilroy-MediumItalic-v2",
            fontSize: 24,
            lineHeight: "32px",
            color: palette.neutral["900"],
        },
        subtitle2Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 20,
            lineHeight: "28px",
            color: palette.neutral["900"],
        },
        subtitle2SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 20,
            lineHeight: "28px",
            color: palette.neutral["900"],
        },
        subtitle2MediumItalic: {
            fontFamily: "Gilroy-MediumItalic-v2",
            fontSize: 20,
            lineHeight: "28px",
            color: palette.neutral["900"],
        },
        subtitle3Medium: {
            fontFamily: "Gilroy-Medium-v2",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        subtitle3SemiBold: {
            fontFamily: "Gilroy-SemiBold-v2",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        subtitle3MediumItalic: {
            fontFamily: "Gilroy-MediumItalic-v2",
            fontSize: 16,
            lineHeight: "24px",
            color: palette.neutral["900"],
        },
        captionMedium: {
            fontFamily: "Gilroy-MediumItalic-v2",
            fontSize: 14,
            lineHeight: "20px",
        },
        captionSemiBold: {
            fontFamily: "Gilroy-SemiBoldItalic-v2",
            fontSize: 14,
            lineHeight: "20px",
            color: palette.neutral["900"],
        },
        buttonV2: {
            fontFamily: "Gilroy-Bold-v2",
            textTransform: "none",
            color: palette.neutral["900"],
        },
        buttonLarge: {
            fontFamily: "Gilroy-Bold-v2",
            textTransform: "none",
            fontSize: 20,
            lineHeight: "20px",
            color: palette.neutral["900"],
        },
        buttonMedium: {
            fontFamily: "Gilroy-Bold-v2",
            textTransform: "none",
            fontSize: 16,
            lineHeight: "16px",
            color: palette.neutral["900"],
        },
        buttonSmall: {
            fontFamily: "Gilroy-Bold-v2",
            textTransform: "none",
            fontSize: 14,
            lineHeight: "14px",
            color: palette.neutral["900"],
        },
        displayLargeSemiBoldInter: (_0 = {
                fontSize: 72,
                lineHeight: "84px",
                fontWeight: 600,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _0[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _0),
        displayLargeBoldInter: (_1 = {
                fontSize: 72,
                lineHeight: "84px",
                fontWeight: 700,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _1[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _1),
        displayLargeExtraBoldInter: (_2 = {
                fontSize: 72,
                lineHeight: "84px",
                fontWeight: 800,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _2[breakpoints.down("md")] = {
                fontSize: 48,
                lineHeight: "60px",
            },
            _2),
        displayMediumSemiBoldInter: (_3 = {
                fontSize: 64,
                lineHeight: "72px",
                fontWeight: 600,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _3[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _3),
        displayMediumBoldInter: (_4 = {
                fontSize: 64,
                lineHeight: "72px",
                fontWeight: 700,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _4[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _4),
        displayMediumExtraBoldInter: (_5 = {
                fontSize: 64,
                lineHeight: "72px",
                fontWeight: 800,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _5[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _5),
        displaySmallSemiBoldInter: (_6 = {
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 600,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _6[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _6),
        displaySmallBoldInter: (_7 = {
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 700,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _7[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _7),
        displaySmallExtraBoldInter: (_8 = {
                fontSize: 56,
                lineHeight: "68px",
                fontWeight: 800,
                letterSpacing: "-0.03em",
                color: palette.neutral["900"],
                fontFamily: "Inter"
            },
            _8[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _8),
        h1SemiBoldInter: (_9 = {
                fontSize: 48,
                lineHeight: "60px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _9[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _9),
        h1BoldInter: (_10 = {
                fontSize: 48,
                lineHeight: "60px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _10[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _10),
        h1ExtraBoldInter: (_11 = {
                fontSize: 48,
                lineHeight: "60px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _11[breakpoints.down("md")] = {
                fontSize: 40,
                lineHeight: "52px",
            },
            _11),
        h2SemiBoldInter: (_12 = {
                fontSize: 40,
                lineHeight: "52px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _12[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _12),
        h2BoldInter: (_13 = {
                fontSize: 40,
                lineHeight: "52px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _13[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _13),
        h2ExtraBoldInter: (_14 = {
                fontSize: 40,
                lineHeight: "52px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _14[breakpoints.down("md")] = {
                fontSize: 32,
                lineHeight: "44px",
            },
            _14),
        h3SemiBoldInter: (_15 = {
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _15[breakpoints.down("md")] = {
                fontSize: 28,
                lineHeight: "36px",
            },
            _15),
        h3BoldInter: (_16 = {
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _16[breakpoints.down("md")] = {
                fontSize: 28,
                lineHeight: "36px",
            },
            _16),
        h3ExtraBoldInter: (_17 = {
                fontSize: 32,
                lineHeight: "44px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _17[breakpoints.down("md")] = {
                fontSize: 28,
                lineHeight: "36px",
            },
            _17),
        h4SemiBoldInter: (_18 = {
                fontSize: 28,
                lineHeight: "36px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _18[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _18),
        h4BoldInter: (_19 = {
                fontSize: 28,
                lineHeight: "36px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _19[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _19),
        h4ExtraBoldInter: (_20 = {
                fontSize: 28,
                lineHeight: "36px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _20[breakpoints.down("md")] = {
                fontSize: 24,
                lineHeight: "32px",
            },
            _20),
        h5SemiBoldInter: (_21 = {
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _21[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _21),
        h5BoldInter: (_22 = {
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _22[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _22),
        h5ExtraBoldInter: (_23 = {
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _23[breakpoints.down("md")] = {
                fontSize: 20,
                lineHeight: "28px",
            },
            _23),
        h6SemiBoldInter: (_24 = {
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 600,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _24[breakpoints.down("md")] = {
                fontSize: 18,
                lineHeight: "24px",
            },
            _24),
        h6BoldInter: (_25 = {
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 700,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _25[breakpoints.down("md")] = {
                fontSize: 18,
                lineHeight: "24px",
            },
            _25),
        h6ExtraBoldInter: (_26 = {
                fontSize: 20,
                lineHeight: "28px",
                fontWeight: 800,
                color: palette.neutral["900"],
                fontFamily: "Inter",
                letterSpacing: "-0.03em"
            },
            _26[breakpoints.down("md")] = {
                fontSize: 18,
                lineHeight: "24px",
            },
            _26),
        subtitle1RegularInter: {
            fontSize: 24,
            fontWeight: 400,
            lineHeight: "32px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle1RegularItalicInter: {
            fontSize: 24,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "32px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle1SemiBoldInter: {
            fontSize: 24,
            fontWeight: 600,
            lineHeight: "32px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle1SemiBoldItalicInter: {
            fontSize: 24,
            fontWeight: 600,
            fontStyle: "italic",
            lineHeight: "32px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle2RegularInter: {
            fontSize: 20,
            fontWeight: 400,
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle2RegularItalicInter: {
            fontSize: 20,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle2SemiBoldInter: {
            fontSize: 20,
            fontWeight: 600,
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle2SemiBoldItalicInter: {
            fontSize: 20,
            fontWeight: 600,
            fontStyle: "italic",
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle3RegularInter: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle3RegularItalicInter: {
            fontSize: 16,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle3SemiBoldInter: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        subtitle3SemiBoldItalicInter: {
            fontSize: 16,
            fontWeight: 600,
            fontStyle: "italic",
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1RegularInter: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1UnderlineInter: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: "28px",
            textDecoration: "underline",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1LineThroughInter: {
            fontSize: 18,
            fontWeight: 400,
            lineHeight: "28px",
            textDecoration: "line-through",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1ItalicInter: {
            fontSize: 18,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1MediumInter: {
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body1SemiBoldInter: {
            fontSize: 18,
            fontWeight: 600,
            lineHeight: "28px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2RegularInter: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2UnderlineInter: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "24px",
            textDecoration: "underline",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2LineThroughInter: {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "24px",
            textDecoration: "line-through",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2ItalicInter: {
            fontSize: 16,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2MediumInter: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body2SemiBoldInter: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: "24px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3RegularInter: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "20px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3UnderlineInter: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "20px",
            textDecoration: "underline",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3LineThroughInter: {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "20px",
            textDecoration: "line-through",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3ItalicInter: {
            fontSize: 14,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "20px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3MediumInter: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: "20px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body3SemiBoldInter: {
            fontSize: 14,
            fontWeight: 600,
            lineHeight: "20px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4RegularInter: {
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "16px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4UnderlineInter: {
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "16px",
            textDecoration: "underline",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4LineThroughInter: {
            fontSize: 12,
            fontWeight: 400,
            lineHeight: "16px",
            textDecoration: "line-through",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4ItalicInter: {
            fontSize: 12,
            fontWeight: 400,
            fontStyle: "italic",
            lineHeight: "16px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4MediumInter: {
            fontSize: 12,
            fontWeight: 500,
            lineHeight: "16px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        body4SemiBoldInter: {
            fontSize: 12,
            fontWeight: 600,
            lineHeight: "16px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        overlineSmallInter: {
            textTransform: "uppercase",
            fontSize: 12,
            lineHeight: "16px",
            letterSpacing: "1px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        overlineMediumInter: {
            textTransform: "uppercase",
            fontSize: 14,
            lineHeight: "20px",
            letterSpacing: "1px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        overlineLargeInter: {
            textTransform: "uppercase",
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "1px",
            color: palette.neutral["900"],
            fontFamily: "Inter",
        },
        captionMediumInter: {
            fontSize: 14,
            fontWeight: 500,
            fontStyle: "italic",
            lineHeight: "20px",
            fontFamily: "Inter",
        },
        captionSemiBoldInter: {
            fontSize: 14,
            fontWeight: 600,
            fontStyle: "italic",
            lineHeight: "20px",
            fontFamily: "Inter",
        },
        buttonSmallInter: {
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "14px",
            color: palette.neutral["900"],
        },
        buttonMediumInter: {
            fontSize: 16,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "16px",
            color: palette.neutral["900"],
        },
        buttonLargeInter: {
            fontSize: 18,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "18px",
            color: palette.neutral["900"],
        },
        buttonSmallUpperInter: {
            fontSize: 14,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "14px",
            textTransform: "uppercase",
            color: palette.neutral["900"],
        },
        buttonMediumUpperInter: {
            fontSize: 16,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "16px",
            textTransform: "uppercase",
            color: palette.neutral["900"],
        },
        buttonLargeUpperInter: {
            fontSize: 18,
            fontFamily: "Inter",
            fontWeight: 600,
            lineHeight: "18px",
            textTransform: "uppercase",
            color: palette.neutral["900"],
        },
    });
};
